import styled from "styled-components";
import { colors } from "assets";

export default c => styled(c)`
  .icon-color svg {
    fill: ${colors.primary.dark};
  }
`;



// WEBPACK FOOTER //
// ./src/components/app/registration/product/inventory/adjust/import-stock-count/style.js